export default __webpack_public_path__ + "static/media/icon_barcode.d69e1eca.svg";